var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-dialog",
    {
      attrs: {
        "data-test": _vm.CypressTarget("DiscountCouponDialog"),
        value: _vm.value
      },
      on: {
        input: function($event) {
          _vm.$emit("input", $event)
        }
      },
      scopedSlots: _vm._u([
        {
          key: "buttons",
          fn: function(props) {
            return [
              _c(
                "div",
                { attrs: { "data-test": _vm.CypressTarget("Buttons") } },
                [
                  _c("q-btn", {
                    attrs: {
                      label: _vm.$t("button.cancel"),
                      "data-test": _vm.CypressTarget("Cancel"),
                      color: _vm.SET_COLOR.buttons.cancel || "dark",
                      flat: ""
                    },
                    nativeOn: {
                      click: function($event) {
                        return props.cancel($event)
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: {
                      "data-test": _vm.CypressTarget("Ok"),
                      disable: _vm.couponCode === "",
                      label: _vm.$t("button.ok"),
                      color: _vm.SET_COLOR.buttons.ok || "dark",
                      flat: ""
                    },
                    on: {
                      click: function($event) {
                        _vm.setCoupon(props.ok, _vm.couponCode)
                      }
                    }
                  })
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "span",
        {
          attrs: { slot: "title", "data-test": _vm.CypressTarget("Title") },
          slot: "title"
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("dialog.discountCoupon.title")) + "\n  "
          )
        ]
      ),
      _c(
        "span",
        {
          attrs: { slot: "message", "data-test": _vm.CypressTarget("Text") },
          slot: "message"
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("dialog.discountCoupon.text")) + "\n  "
          )
        ]
      ),
      _c("div", { attrs: { slot: "body" }, slot: "body" }, [
        _c("div", { staticClass: "row q-ma-sm" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-field",
                [
                  _c("q-input", {
                    staticClass: "event-coupon-code",
                    attrs: {
                      "data-test": _vm.CypressTarget("Input"),
                      color: _vm.SET_COLOR.primary,
                      "float-label": _vm.$t("field.payment.discount.code"),
                      type: "text",
                      required: ""
                    },
                    model: {
                      value: _vm.couponCode,
                      callback: function($$v) {
                        _vm.couponCode = $$v
                      },
                      expression: "couponCode"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }